// extracted by mini-css-extract-plugin
export default {"root":"Error-module_root-jWMEz"};